// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"38badb71","109":"820e6f39","124":"d9354567","328":"e641cd1f","338":"abbd439c","534":"3ce9f090","544":"0f7fda66","576":"d9dee2ea","720":"dd9beb5f","753":"71764b33","775":"bd76043b","823":"1f1755b6","870":"2f84891d","990":"4ed65a22","996":"27edc69b"}[chunkId] + ".js";
};